import { __ } from '@wordpress/i18n';
import { useSelect } from 'downshift';

import { Region } from '../../../../types';
import { CaretIcon } from '../icons/icons';

export default function RegionSelect( { wpRegionTerms, handleRegionChange, region } : {
	wpRegionTerms: Region[];
	handleRegionChange: Function;
	region: Region;
} ) {
	function itemToString( item: Region ) {
		return item ? item.name : '';
	}

	const {
		getToggleButtonProps,
		getLabelProps,
		getMenuProps,
		getItemProps,
		isOpen,
		selectedItem,
		highlightedIndex,
	} = useSelect( {
		items: wpRegionTerms,
		itemToString,
		selectedItem: region,
		onSelectedItemChange: ( { selectedItem: newSelectedItem } ) => {
			handleRegionChange( newSelectedItem );
		},
	} );

	const hasRegionTerms = wpRegionTerms?.length > 0;

	return (
		<div className="tcc-map__filter tcc-map__filter--region">
			<div className="tcc-map__filter-input-wrapper">
				<label
					className="tcc-map__filter-label screen-reader-text"
					{ ...getLabelProps() }
					htmlFor="tcc-map__filter-input--region"
				>
					{ __( 'Select a Region', 'tcc-map' ) }
				</label>
				<button
					className="tcc-map__filter-input"
					type="button"
					{ ...getToggleButtonProps() }
					id="tcc-map__filter-input--region"
					disabled={ ! hasRegionTerms }
				>
					<span className="tcc-map__filter-input-text">{ selectedItem ? selectedItem.name : __( 'Regions', 'tcc-map' ) }</span>
					<span className="tcc-map__filter-input-icon">
						<CaretIcon />
					</span>
				</button>
			</div>
			{ hasRegionTerms && (
				<ul
					className={ `tcc-map__filter-options ${ isOpen && 'visible' }` }
					{ ...getMenuProps() }
				>
					{ isOpen && wpRegionTerms.map( ( item: Region, index: number ) => (
						<li
							className={ `tcc-map__filter-option ${ highlightedIndex === index ? 'highlighted' : '' } ${ selectedItem === item ? 'selected' : '' }` }
							key={ item.term_id }
							{ ...getItemProps( { item, index } ) }
						>
							<span>{ item.name }</span>
						</li>
					) ) }
				</ul>
			) }
		</div>
	);
}
